<template>
    <div ref="mapview" class="map-view">
        <div v-if="showResults" class="map-view-list">
            <ais-stats>
                <p slot-scope="{ nbHits }">{{ nbHits }} results</p>
            </ais-stats>

            <ais-hits>
                <template slot="item" slot-scope="{ item }">
                    <component
                        :is="$root.index == 'installers' ? 'MapViewInstaller' : 'MapViewRetailer'"
                        :id="`marker-${item.id}`"
                        :item="item"
                        :active-marker="activeMarker"
                        @click.native="activeMarker = item"
                    />
                </template>
            </ais-hits>
        </div>

        <GeoSearch
            ref="geosearch"
            class="map-view-map"
            :active-marker="activeMarker"
            @active-sidebar="showResults = $event"
            @set-active-marker="setActiveMarker($event)"
        />
    </div>
</template>

<script>
import GeoSearch from './GeoSearch';
import MapViewInstaller from './MapViewInstaller';
import MapViewRetailer from './MapViewRetailer';

export default {
    components: {
        MapViewInstaller,
        MapViewRetailer,
        GeoSearch
    },

    data() {
        return {
            showResults: false,
            activeMarker: null
        };
    },

    methods: {
        // Pass search results down to map
        setBounds(latlng) {
            this.$refs.geosearch.setBounds(latlng);
        },

        setActiveMarker(marker) {
            if (this.activeMarker && this.activeMarker.id === marker.id) {
                this.activeMarker = null;
            } else {
                this.activeMarker = marker;

                const scroll = setInterval(() => {
                    const infobox = this.$refs.mapview.querySelector(`#marker-${marker.id}`);
                    if (infobox) {
                        infobox.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest',
                            inline: 'start'
                        });
                        clearInterval(scroll);
                    }
                }, 500);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.map-view {
    display: flex;
    height: 100vh;
    overflow: hidden;
    border-bottom: 1px solid #dddddd;

    @media screen and (min-width: 769px) {
        max-height: 700px;
    }
}

.map-view-list {
    display: none;
    width: 420px;
    padding: 0 1em;
    overflow: auto;

    @media screen and (min-width: 769px) {
        display: block;
    }
}

.map-view-map {
    flex: 1;
}

.ais-Stats {
    margin-top: 2em;
    margin-bottom: 1em;
    font-size: 14px;
    font-weight: 500;
}
</style>
